export default __webpack_public_path__ + "static/media/fam9.d485b4e3.png";